import { styled } from '@mui/material';
import { LoadingButton, LoadingButtonProps } from '@mui/lab';

export const StyledLoadingButton = styled(LoadingButton)<LoadingButtonProps>`
  &:hover {
    background-color: ${({ theme }) => theme.palette.grey['300']};
  }
`;
